import { render, staticRenderFns } from "./AllowListModal.vue?vue&type=template&id=16066300&scoped=true"
import script from "./AllowListModal.vue?vue&type=script&lang=js"
export * from "./AllowListModal.vue?vue&type=script&lang=js"
import style0 from "./AllowListModal.vue?vue&type=style&index=0&id=16066300&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16066300",
  null
  
)

export default component.exports